<ng-container *ngIf="block && block.length">
    <div class="d-flex flex-wrap no-print">
        <div class="cursor-pointer" *ngFor="let item of block" class="{{ classColumn }}" 
            [routerLink]="navigationService.splitUrlRouterLink(retriveField(item.url)).path" 
            [queryParams]="navigationService.splitUrlRouterLink(retriveField(item.url)).queryParams">
            <div class="card d-flex justify-content-between p-4" [ngClass]="item.field_status || item.status === 'Aperto' ? 'status-aperto' : 'status-chiuso'">
                <div>
                    <div *ngIf="item.field_status || item.status" class="badge text-neutral-99 text-uppercase ls-label-small-semibold"
                        [class.bg-error-40]="item.field_status === 'Chiuso' || item.status === 'Chiuso'" [class.bg-success-40]="item.field_status === 'Aperto' || item.status === 'Aperto'">
                        {{item.field_status === 'Aperto' || item.status === 'Aperto' ? ("BLOCK.SAMPLE_SINGLE_ANNOUNCEMENT.OPEN" | translate) : ("BLOCK.SAMPLE_SINGLE_ANNOUNCEMENT.CLOSED" | translate)}}
                    </div>
                    <div *ngIf="item.field_titolo || item.titolo || item.title" class="pb-1 pt-4">
                        <h2 class="mb-0 ls-h3-item-title text-brand-10 title-announcement" [innerHTML]="item.field_titolo || item.titolo || item.title"></h2>
                    </div>
                    <div *ngIf="item.field_scadenza || item.scadenza">
                        <div *ngIf="item.field_status === 'Chiuso' || item.status === 'Chiuso'" [ngClass]="{'pt-4': !item.field_titolo || !item.titolo || item.title}">
                            <p class="ls-label-small-semibold text-uppercase text-error-30 mb-1">
                                {{"BLOCK.SAMPLE_SINGLE_ANNOUNCEMENT.EXPIRED" | translate}}
                                {{ getDate(item.field_scadenza || item.scadenza).date }}
                            </p>
                            <!-- <p *ngIf="getDate(item.field_scadenza || item.scadenza).time" class="ls-label-small-semibold text-uppercase text-error-30">
                                {{ ("BLOCK.SAMPLE_SINGLE_ANNOUNCEMENT.AT" | translate) + getDate(item.field_scadenza || item.scadenza).time }}
                            </p> -->
                        </div>
                        <div *ngIf="item.field_status === 'Aperto' || item.status === 'Aperto'">
                            <p class="ls-label-small-semibold text-uppercase text-success-30 mb-1">
                                {{"BLOCK.SAMPLE_SINGLE_ANNOUNCEMENT.EXPIRES" | translate}}
                                {{ getDate(item.field_scadenza || item.scadenza).date }}
                            </p>
                            <!-- <p *ngIf="getDate(item.field_scadenza || item.scadenza).time" class="ls-label-small-semibold text-uppercase text-success-30">
                                {{ ("BLOCK.SAMPLE_SINGLE_ANNOUNCEMENT.AT" | translate) + getDate(item.field_scadenza || item.scadenza).time }}
                            </p> -->
                        </div>
                    </div>
                </div>
                <div>
                    <div *ngIf="item.tassonomia_dipartimento && item.tassonomia_dipartimento.length"
                        class="d-flex flex-column">
                        <p class="ls-label-small-semibold text-neutral-30 mb-1 text-uppercase">
                            {{"BLOCK.SAMPLE_SINGLE_ANNOUNCEMENT.DEPARTMENT" | translate}}</p>
                        <p class="ls-label-small-semibold text-neutral-60 text-uppercase">
                            <span *ngFor="let dip of item.tassonomia_dipartimento; let i = index"
                            innerHTML="{{dip.name}}{{ (i !== (item.tassonomia_dipartimento.length - 1)) ? ',' : ''}}">
                                
                            </span>
                        </p>
                    </div>
                    <div *ngIf="item.tassonomia_categoria_bando && item.tassonomia_categoria_bando.length"
                        class="d-flex flex-column">
                        <p class="ls-label-small-semibold text-neutral-30 mb-1 text-uppercase">
                            {{"BLOCK.SAMPLE_SINGLE_ANNOUNCEMENT.ANNOUNCEMENT_FOR" | translate}}</p>
                        <p class="ls-label-small-semibold text-neutral-60 text-uppercase">
                            <span *ngFor="let cat of item.tassonomia_categoria_bando; let i = index"
                            innerHTML="{{cat.name}}{{ (i !== (item.tassonomia_categoria_bando.length - 1)) ? ',' : ''}}">
                                
                            </span>
                        </p>
                    </div>
                </div>
            </div>
        </div>
    </div>
    <ng-container *ngFor="let item of block">
        <app-sample-print 
            [title]="item.field_titolo || item.titolo || item.title" 
            [subtitle]='((item.field_status === "Aperto" || item.status === "Aperto") ? 
                        ("BLOCK.SAMPLE_SINGLE_ANNOUNCEMENT.OPEN" | translate) : 
                        ("BLOCK.SAMPLE_SINGLE_ANNOUNCEMENT.CLOSED" | translate) 
                        + " " + 
                        (getDate(item.field_scadenza || item.scadenza).time ? (("BLOCK.SAMPLE_SINGLE_ANNOUNCEMENT.AT" | translate) + getDate(item.field_scadenza || item.scadenza).time) : ""))'
            [taxonomies]="item.tassonomia_dipartimento"
            [taxonomies2]="item.tassonomia_categoria_bando">
        </app-sample-print>
    </ng-container>
</ng-container>
<ng-container *ngIf="block && !block.length">
    <div class="d-flex flex-wrap no-print" 
        [routerLink]="navigationService.splitUrlRouterLink(block.link ? block.link : nodeService.retriveLinkTagA(block.field_titolo, 'a').link ? 
                        nodeService.retriveLinkTagA(block.field_titolo, 'a').link : '/').path" 
        [queryParams]="navigationService.splitUrlRouterLink(block.link ? block.link : nodeService.retriveLinkTagA(block.field_titolo, 'a').link ? 
        nodeService.retriveLinkTagA(block.field_titolo, 'a').link : '/').queryParams">
        <div class="card d-flex justify-content-between p-4 {{ classColumn }}" [ngClass]="block.field_status === 'Aperto' ? 'status-aperto' : 'status-chiuso'">
            <div>
                <div *ngIf="block.field_status" class="badge text-neutral-99 text-uppercase ls-label-small-semibold"
                    [class.bg-error-40]="block.field_status === 'Chiuso' || block.status === 'Chiuso'"
                    [class.bg-success-40]="block.field_status === 'Aperto' || block.status === 'Aperto'">
                    {{block.field_status === 'Aperto' ? ("BLOCK.SAMPLE_SINGLE_ANNOUNCEMENT.OPEN" | translate) : ("BLOCK.SAMPLE_SINGLE_ANNOUNCEMENT.CLOSED" | translate)}}
                </div>
                <div class="pb-1 pt-4">
                    <a *ngIf="block.field_titolo">
                        <h2 class="mb-0 ls-h3-item-title text-brand-10 title-announcement" [innerHTML]="block.field_titolo"></h2>
                    </a>
                </div>
                <div *ngIf="block.field_scadenza">
                    <div *ngIf="block.field_status === 'Aperto'" >
                        <p class="ls-label-small-semibold text-uppercase text-error-30 mb-0">
                            {{"BLOCK.SAMPLE_SINGLE_ANNOUNCEMENT.EXPIRED" | translate}}
                            {{ getDate(block.field_scadenza) | localizedDate:'dd/MM/yyyy'}}
                        </p>
                        <p *ngIf="getDate(block.field_scadenza || block.scadenza).time" class="ls-label-small-semibold text-uppercase text-error-30">{{ ("BLOCK.SAMPLE_SINGLE_ANNOUNCEMENT.AT" | translate) + getDate(block.field_scadenza || block.scadenza).time }}</p>
                    </div>
                    <div *ngIf="block.field_status === 'Chiuso'">
                        <p class="ls-label-small-semibold text-uppercase text-success-30 mb-0">
                            {{"BLOCK.SAMPLE_SINGLE_ANNOUNCEMENT.EXPIRES" | translate}}
                            {{ getDate(block.field_scadenza) | localizedDate:'dd/MM/yyyy'}}
                        </p>
                        <p *ngIf="getDate(block.field_scadenza || block.scadenza).time" class="ls-label-small-semibold text-uppercase text-success-30">{{ ("BLOCK.SAMPLE_SINGLE_ANNOUNCEMENT.AT" | translate) + getDate(block.field_scadenza || block.scadenza).time }}</p>
                    </div>

                </div>
            </div>
            <div>
                <div *ngIf="block.field_tassonomia_dipartimento && block.field_tassonomia_dipartimento.length"
                    class="d-flex flex-column">
                    <p class="ls-label-small-semibold text-neutral-30 mb-1 text-uppercase">
                        {{"BLOCK.SAMPLE_SINGLE_ANNOUNCEMENT.DEPARTMENT" | translate}}</p>
                    <p class="ls-label-small-semibold text-neutral-60 text-uppercase">
                        <span *ngFor="let dip of block.field_tassonomia_dipartimento; let i = index"
                        innerHTML="{{dip.name}}{{ (i !== (block.field_tassonomia_dipartimento.length - 1)) ? ',' : ''}}">
                            
                        </span>
                    </p>
                </div>
                <div *ngIf="block.field_tassonomia_categoria_bando && block.field_tassonomia_categoria_bando.length"
                    class="d-flex flex-column">
                    <p class="ls-label-small-semibold text-neutral-30 mb-1 text-uppercase">
                        {{"BLOCK.SAMPLE_SINGLE_ANNOUNCEMENT.ANNOUNCEMENT_FOR" | translate}}</p>
                    <p class="ls-label-small-semibold text-neutral-60 text-uppercase">
                        <span *ngFor="let cat of block.field_tassonomia_categoria_bando; let i = index"
                        innerHTML="{{cat.name}}{{ (i !== (block.field_tassonomia_categoria_bando.length - 1)) ? ',' : ''}}">
                            
                        </span>
                    </p>
                </div>
            </div>
        </div>
    </div>
    <app-sample-print 
        [title]="block.field_titolo" 
        [subtitle]='(block.field_status === "Aperto" ? 
                    ("BLOCK.SAMPLE_SINGLE_ANNOUNCEMENT.OPEN" | translate) : 
                    ("BLOCK.SAMPLE_SINGLE_ANNOUNCEMENT.CLOSED" | translate) 
                    + " " + 
                    (getDate(block.field_scadenza || block.scadenza).time ? (("BLOCK.SAMPLE_SINGLE_ANNOUNCEMENT.AT" | translate) + getDate(block.field_scadenza || block.scadenza).time) : ""))'
        [taxonomies]="block.tassonomia_dipartimento"
        [taxonomies2]="block.tassonomia_categoria_bando">
    </app-sample-print>
</ng-container>